import React from "react"
import {BankSettings, isBankSettingsWithLegalDocs} from "../../resources/bankSettings"
import DomainSetup from "./DomainSetup"
import DnsDomainView from "./DnsDomainView"
import Card from "../../containers/Card/Card"

export default function LegalDocs({bankSettings, refresh}: {bankSettings: BankSettings; refresh: () => void}) {
	return (
		<Card title="Legal Docs">
			<form>
				{isBankSettingsWithLegalDocs(bankSettings) ? (
					<DnsDomainView
						dnsDomain={bankSettings.attributes.legalDocsSettings.dnsDomain}
						refresh={refresh}
						status={bankSettings.attributes.legalDocsSettings.certificateStatus}
					/>
				) : (
					<DomainSetup refresh={refresh} />
				)}
			</form>
		</Card>
	)
}
